import { Periods } from '@shared/utils/History/TFInfo';
import { HistoryMergerBasedByDay } from './HistoryMergerBasedByDay';
export class HistoryMergerMonth extends HistoryMergerBasedByDay {
    constructor(inputParams) {
        super(inputParams);
    }
    GetDaysInPeriod(dateTime) {
        let result = 0;
        let currentDate = dateTime;
        for (let i = 0; i < this.GetCount(); i++) {
            result += currentDate.daysInMonth;
            currentDate = currentDate.plus({ months: 1 });
        }
        return result;
    }
    IsStartPeriodDate(dateTime) {
        return dateTime.day === 1;
    }
    GetBasePeriod() {
        return Periods.MONTH;
    }
}
